import axios from 'lib/axios'

export interface ActiveInventory {
  id: number
  name: string
  subscriptionName: string
  credits: number
  usedCredits: number
  creditsAvailable: number
  expirationDate: string
  isUnlimited: boolean
}

interface ActiveInventoriesResponse {
  status: string
  data?: Array<{
    subscription_company_id: number
    subscriptionName: string
    credits: number
    usedCredits: number
    creditsAvailable: number
    expiration_date: string
    isUnlimited: boolean
  }>
}

const fetchActiveInventories = async (companyId: number): Promise<ActiveInventory[]> => {
  try {
    const response: ActiveInventoriesResponse = await axios
      .get(`/subscription/${companyId}?status=true&limit=100`)
      .then((res) => res.data)

    if (response.status !== 'OK' || !response.data) {
      return []
    }

    return response.data.map((inventory) => ({
      id: inventory.subscription_company_id,
      name: inventory.subscriptionName,
      subscriptionName: inventory.subscriptionName,
      credits: Number(inventory.credits),
      usedCredits: Number(inventory.usedCredits),
      creditsAvailable: Number(inventory.creditsAvailable),
      expirationDate: inventory.expiration_date,
      isUnlimited: inventory.isUnlimited,
    }))
  } catch (error) {
    return []
  }
}

export default fetchActiveInventories
